import * as React from 'react';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { setInnerHtml } from 'sos-common/js/utils/helpers';

export interface IYrkeSpecificInforutaProps {}
export interface IYrkeSpecificInforutaState extends FormSectionBaseState {}

export default class YrkeSpecificInforuta extends FormSectionBase<
  IYrkeSpecificInforutaProps,
  IYrkeSpecificInforutaState
> {
  constructor(props: IYrkeSpecificInforutaProps) {
    super(props);

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  public render() {
    const { isInEditMode, model, yrkeSpecificInformationBoxes } = this.context;
    return (
      <>
        {!model.yrkeId && isInEditMode && (
          <div className="importantinfo">
            Meddelande till redaktör: Denna information redigeras per yrke på yrkessidorna.
          </div>
        )}
        {model.yrkeId && (
          <div
            className="importantinfo"
            dangerouslySetInnerHTML={setInnerHtml(yrkeSpecificInformationBoxes.get(model.yrkeId))}></div>
        )}
      </>
    );
  }
}
